import React, { useEffect } from "react";
import ContactUsHero from "../components/contactUsPage/ContactUsHero";
import Navbar from "../components/homepage/Navbar";
 
import ContactUsDetails from "../components/contactUsPage/ContactUsDetails";
import { Header, Footer } from "../shared";

const ContactUsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <ContactUsHero />
      <ContactUsDetails />
      <Footer />
    </div>
  );
};

export default ContactUsPage;
